// Zählt, ob gerade die Seite „Ihr Zugang ruht“ (ZugangRuht.tsx) steht. Dann öffnet UpgradeDialog.tsx für denselben
// Fehler kein zweites Fenster.
let sichtbar = 0;

export function ruhtAngezeigt(): () => void {
  sichtbar++;
  return () => {
    sichtbar--;
  };
}

export const ruhtSeiteSichtbar = () => sichtbar > 0;
